// components/Loader.js
import React from 'react';
import "./Loader.css";

const Loader = () => (
  <div className="text-center main-loader-block">
    <div className='main-loader'>
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  </div>
);

export default Loader;
